// extracted by mini-css-extract-plugin
export default {"direction-header":"M1bq6dPoHn","directionHeader":"M1bq6dPoHn","policy-source":"HjVbDaPUR5","policySource":"HjVbDaPUR5"};